<template lang="">
    <div class="notification-card">
        <div class="d-flex justify-content-between align-items-center gap-2">
            <span>Notifications</span>
            <button class="btn text-primary p-0" @click="marquez_lue">Marqué tout comme lus</button>
        </div><br>
        <div>
            <div v-if="showLess">
                <ul class="list-none p-0 notification-card-content py-2" v-for="alerte in notification_alertes" :key="alerte.uuid">
                    <li class="d-flex justify-content-between" @click="goToAlertes(alerte)">
                        <div class="">
                            <p class="m-0 default fwb">{{ alerte.patient.name }}</p>
                            <p class="m-0 text-secondary">Alerte: Niveau {{ alerte.niveau_urgence_id }}</p>
                        </div>
                        <i class="fa-solid fa-circle text-primary mt-1"></i>
                    </li>
                    <li class="d-flex justify-content-between text-gray notif-date">
                        <span>Date et Heure:</span><span>{{ formattedDateTime(alerte.created_at) }}</span>
                    </li>
                </ul>
                <ul class="list-none p-0 notification-card-content py-2" v-for="notification in (notifications || notifications.data)" :key="notification.id">
                    <li class="d-flex justify-content-between" @click="goToAlertes(notification.data)">
                        <div class="">
                            <p class="m-0 default fwb">{{ notification.data.patient.name }}</p>
                            <p class="m-0 text-secondary">Alerte: Niveau {{ notification.data.niveau_urgence_id }}</p>
                        </div>
                        <i class="fa-solid fa-circle text-primary mt-1"></i>
                    </li>
                    <li class="d-flex justify-content-between text-gray notif-date">
                        <span>Date et Heure:</span><span> {{ formattedDateTime(notification.created_at) }}</span>
                    </li>
                </ul>
            </div>
            <li class="list-none border-top py-2 text-primary cursor-pointer">
                <router-link to="/notifications" class="text-primary">Voir toutes les notifications</router-link>
            </li>
        </div>
    </div>
</template>
<script>

import moment from "moment";
import {mapGetters} from "vuex";
export default {
    props: ['openNotif'],
    computed: {
        ...mapGetters(["patients", "errors", 'hasAdminRole', 'hasGestionnaireRole', 'notification_alertes', 'notifications']),

        mPatients: function() {
            let pArray = [];

            _.forEach(this.patients, function(patient) {
                //console.log(patient);
                if (typeof patient.user == 'object'){
                    let user = patient.user;
                    if(user != null){
                        if (typeof patient.dossier == "object"){
                            let dossier  = patient.dossier;
                            if(dossier != null  ){
                                let prenom = (user.prenom != null && user.prenom) ?  user.prenom : '' ;
                                prenom =  prenom.toLowerCase();
                                let text = (user.nom).toUpperCase()+" "+ prenom.charAt(0).toUpperCase() + prenom.substring(1) +" ("+ dossier.numero_dossier +")";
                                pArray.push({text: text, value: patient.user_id });
                            }
                        }
                    }
                }
            });
            return pArray;
        },
    },
     data() {
        return {
            alerte:{},
            showLess: true,
            alertForm: false,
            settings: false,
            singleAlert:{},
            Home: false,
            mobileView: true,
            }},
    methods: {
        goToAlertes(alerte){
            if(this.$router.currentRoute.query.uuid == undefined){
                this.$router.push('/alertes?uuid='+alerte.uuid);
            }else{
                window.location.href = '/alertes?uuid='+alerte.uuid;
            }
        },
        marquez_lue(){
            let args = {
                offset: this.offset,
                limit: this.limit
            };
            this.$store.dispatch("MarquezCommeLues", {args});
        },
        formattedDateTime(date) {
            if (moment(date).isValid() && date != null) {
                return moment(date).format("DD-MM-YYYY à HH:mm");
            } else {
                return date;
            }
        },
        getPatients() {
            let args = {
                offset: this.offset,
                limit: this.limit
            };

            this.$store.dispatch('getPatients', { args : args });
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            // this.nameState = valid
            this.patientState = valid
            this.statutState = valid
            this.niveaUrgenceState = valid
            this.plainteState = valid

            return valid
        },
        resetModal() {
            this.plainte = ''
            this.patient_id = ''
            this.statut_id =''
            this.niveau_urgence_id = ''
            // this.nameState = null
            this.patientState = null
            this.statutState = null
            this.niveaUrgenceState = null
            this.plainteState = null
        },
        handleOk(bvModalEvent) {
            // Prevent modal from closing
            bvModalEvent.preventDefault()
            // Trigger submit handler
            this.handleSubmit()
        },
        handleSubmit() {
            // Exit when the form isn't valid
            if (!this.checkFormValidity()) {
            return
            }
            // Push the name to submitted names
            this.submittedNames.push(this.alerte)
            let args = {};

            args.patient_id = this.alerte.patient_id;
            args.statut_id = this.alerte.statut_id;
            args.niveau_urgence_id = this.alerte.niveau_urgence_id;
            args.plainte = this.alerte.plainte;

            console.log(args);

            let successMessage = this.$i18n.t('message.assistanteCreated');
            let errorMessages = {
            generic: this.$i18n.t('message.genericError'),
            error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
            };

            this.$store.dispatch('createAlerte', { args, errorMessages, successMessage })
            // Hide the modal manually
            this.$nextTick(() => {
            this.$bvModal.hide('modal-prevent-closing')
            })
        },
        getAlertes() {
            let args = {
                offset: this.offset,
                limit: this.limit,
                id:(JSON.parse(localStorage.getItem('user')))['id']
            };

            this.$store.dispatch('getAlertes', { args : args });
        },
        infoModal(cmd) {
          this.settings=true,  
            this.$bvModal.show('modalInfo');
            this.singleAlert=cmd
            
        },
        handleView() {
            this.mobileView = window.innerWidth <= 990;
        },

        // onSubmit(evt){
        //     evt.preventDefault();

        //     this.$v.$touch();

        //     if(!this.$v.$invalid) {
        //         let args = {};

        //         args.patient_id = this.alerte.patient_id;
        //         args.statut_id = this.alerte.statut_id;
        //         args.niveau_urgence_id = this.alerte.niveau_urgence_id;
        //         args.plainte = this.alerte.plainte;
                
        //         console.log(args);

        //         let successMessage = this.$i18n.t('message.assistanteCreated');
        //         let errorMessages = {
        //         generic: this.$i18n.t('message.genericError'),
        //         error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        //         };

        //         this.$store.dispatch('createAlerte', { args, errorMessages, successMessage })

        //     }
        // },
    },
    mounted() {

    }
    
}
</script>

<style>

</style>